import React from 'react';

import Heading from '@atlaskit/heading';
import { Inline } from '@atlaskit/primitives/compiled';

import type { PreviewPanelTitleProps } from './types';

export const PreviewPanelTitle = ({ title, icon }: PreviewPanelTitleProps) => {
	return (
		<Inline space="space.100" alignBlock="center">
			{icon}
			<Heading size="xsmall">{title}</Heading>
		</Inline>
	);
};
